/* oxlint-disable import/default, import/no-duplicates, simple-import-sort/imports */

// Vite needs this query import in the client file. If it lives in the worker
// module, Vite tries to bundle the worker into itself.
import CompressViewSpecWorkerBundle from './compressViewSpec.worker?worker&inline';
import {
  COMPRESS_VIEW_SPEC_REQUEST,
  compressViewSpecWebWorker,
} from './compressViewSpec.worker';

export async function compressSpecInWorker(data: any): Promise<string | null> {
  const result = await compressViewSpecWebWorker.run(
    () => new CompressViewSpecWorkerBundle(),
    {
      type: COMPRESS_VIEW_SPEC_REQUEST,
      spec: data,
    }
  );

  if (!result.isSuccess) {
    throw new Error(result.error);
  }
  return result.compressed;
}
